export default __webpack_public_path__ + "static/media/gallery_19.fb91e9ab.jpg";